import Vue from 'vue';
import UmyUi from 'umy-ui';
import 'umy-ui/lib/theme-chalk/index.css'; // 引入样式
import App from './App.vue';
import router from './router';
import store from './store';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueSticky from 'vue-sticky';
import VueCookies from 'vue-cookies';
import helper from './assets/js/helper.js';
import 'default-passive-events';
import VueCoreVideoPlayer from 'vue-core-video-player';
import './plugins/element.js';
import './assets/css/global.scss';
import './assets/css/icon_font.css';
import { leaveAndClickDirective } from '@assets/js/customDirectives';

Vue.use(VueCoreVideoPlayer);

Vue.use(VueAxios, axios);
Vue.use(VueCookies);
Vue.use(UmyUi);
Vue.config.productionTip = false;
Vue.prototype.helper = helper;
Vue.directive('leave-and-click', leaveAndClickDirective);

Vue.prototype.jump = (p, q) => {
  router.push({ path: p, query: q }).catch(err => err);
};
// Vue.prototype.bus = new Vue()
Vue.prototype.$EventBus = new Vue();
// el-table表头吸顶效果
Vue.directive('sticky', VueSticky);

router.beforeEach((to, from, next) => {
  if (Vue.prototype.$cookies.get('userInfo')) {
    next();
  } else {
    if (to.fullPath === '/login') {
      next();
    } else {
      next({ path: '/login' });
    }
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
